import template from './feature.template.html'

/* @ngInject */
export default function featureVideoDirective() {
  return {
    template
  }
}
